import {css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';

import {hoverInfo, widgetButton} from '../../css/styleSets';
import {SpcChoiceValue} from './spcChoiceValue';

@customElement('spc-choice-value-combo')
export class SpcChoiceValueCombo extends SpcChoiceValue {

	static styles = [
		widgetButton,
		hoverInfo,
		css`
			:host {
				display: contents;
			}

			.item {
				position: relative;
				margin-bottom: 0;
				width: auto;
			}

			.hidden {
				display: none;
			}

			.item button {
				display: flex;
				align-items: center;
				justify-content: center;
			}
			button svg {
				fill: currentColor;
				width: 16px;
				height: 16px;
			}
		`];

}
